<template>
	<div :class="{'macro-item-row-hover' : !isEdit, 'macro-item-row': isEdit}" class="flex-center w-100 relative" @mouseover="hover = true" @mouseleave="hover = false">
		<div class="w-75">
			<div  @mouseover="hover = true" @mouseleave="hover = false" class="handle-macro-list">
				<item-option
					:item="data.rundownItem"
					:item-macro="data"
					v-if="!isEdit"
				/>
			</div>
			<div
				class="flex-center"
				v-if="isEdit">
				<!-- Rundown Item -->
				<md-menu
					v-if="notRundown"
					class="h-fc w-70 mr-2 mw-170px handle-macro-list"
					md-size="small"
					md-direction="bottom-start"
					md-align-trigger>
					<div
						class="form-control cur-p"
						md-menu-trigger>
						<item-option
							:shortField="true"
							:isEdit="true"
							:item="selectedRundownItem"
							v-if="selectedRundownItem"
						/>
					</div>
					<md-menu-content>
						<md-menu-item
							v-for="rundownItem in rundownItems"
							:key="rundownItem.id"
							@click="selectItem(rundownItem)">
							<item-option :item="rundownItem" />
						</md-menu-item>
					</md-menu-content>
				</md-menu>
				<!-- if item is rundown -->
				<div v-if="!notRundown">
					<div
						class="text-white cur-p handle-macro-list"
						md-menu-trigger>
						<div v-if="selectedAction.label === 'Clear Output'">Clear Output Command</div>
						<div v-if="selectedAction.label === 'Stop All'">Stop All Command</div>
						<div v-if="selectedAction.label === 'Play Previous'">Play Previous Command</div>
						<div v-if="selectedAction.label === 'Play Next'">Play Next Command</div>
					</div>
				</div>
				<!-- layer index edit -->
				<custom-input
					v-if="notRundown"
					type="number"
					class="form-control layer-index-macro pl-2 pr-2 minw-100 pl-4"
					:min="1"
					:max="100"
					:step="1"
					v-model="index"
				/>
				<!--action -->
				<md-menu
					v-if="notRundown"
					class="h-fc w-30 handle-macro-list"
					md-size="small"
					md-direction="bottom-start"
					md-align-trigger>
					<div
						class="form-control cur-p maxw-100"
						md-menu-trigger>
						<div
							v-if="selectedAction">
							{{ $t(selectedAction.label) }}
						</div>
						<div v-else>{{ $t('None') }}</div>
					</div>
					<md-menu-content class="macro-action-edit">
						<md-menu-item
							@click="selectAction(action)"
							v-for="action in actions"
							:key="action.key">
							{{ $t(action.label) }}
						</md-menu-item>
					</md-menu-content>
				</md-menu>
				<!-- if item is rundown -->
				<div v-if="!notRundown">
					<md-menu
						class="h-fc w-30 absolute edit-select-rundown-macro maxw-100 handle-macro-list"
						md-size="small"
						md-direction="bottom-start"
						md-align-trigger>
						<div
							class="form-control cur-p"
							md-menu-trigger>
							<div
								v-if="selectedAction">
								{{ $t(selectedAction.label) }}
							</div>
							<div v-else>{{ $t('None') }}</div>
						</div>
						<md-menu-content>
							<md-menu-item
								@click="selectAction(actionCustom)"
								v-for="actionCustom in actionCustom"
								:key="actionCustom.key">
								{{ $t(actionCustom.label) }}
							</md-menu-item>
						</md-menu-content>
					</md-menu>
					<!-- delay macro -->
					<div class="form-group mb-0">
						<custom-input
						type="number"
							class="form-control edit-select-rundown-macro-delay pl-4"
							:min="0"
							:max="60000"
							:step="100"
							v-model="delay"
						/>
					</div>
				</div>
				<!-- delay macro -->
				<div v-if="notRundown" class="form-group mb-0 pr-2 ml-2">
					<custom-input
						type="number"
						class="form-control delay-macro-edit pl-4"
						:min="0"
						:max="60000"
						:step="100"
						v-model="delay"
					/>
				</div>
			</div>
			<!-- new -->
		</div>
		<!-- button action -->
		<div class="pl-5">
			<div v-if="!isEdit"
				class="d-flex"
				>
				<button
					type="button"
					class="btn btn-icon absolute btn-default mt-2 mr-2 d-flex justify-content-center edit-macro-inside"
					@click="edit"
					v-tooltip="$t('Edit Item')">
					<i class="material-icons">edit</i>
				</button>
				<button
					type="button"
					class="btn btn-icon absolute btn-danger mr-0 mt-2 d-flex justify-content-center delete-macro-inside"
					@click="remove"
					v-tooltip="$t('Delete Item')">
					<i v-if="!isRemoving" class="material-icons">delete</i>
				</button>
				<div v-if="isRemoving" class="is-loading delete-macro-loading"></div>
			</div>
			<button v-if="isEdit"
				type="button"
				class="btn btn-icon btn-default mr-0 d-flex
				justify-content-center"
				:class="{ 'is-loading': isSavingCustom }"
				@click="save"
				v-tooltip="$t('Update Item')"
				>
				<i class="material-icons">save</i>
			</button>
		</div>
	</div>
</template>

<script>
import ItemOption from '@/components/ItemOption.vue';
import macroItemsApi from '@/api/macro-items';
import CustomInput from '@/components/CustomInput.vue';
import { duplicateVar } from '../lib/helper';
import { macroItemActions, macroItemActionsCustom } from '../lib/statics';

export default {
	name: 'MacroItemRow',
	props: {
		data: {
			type: Object,
		},
		rundownItems: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		ItemOption,
		CustomInput,
	},
	data() {
		return {
			selectedRundownItem: null,
			selectedAction: null,
			isEdit: false,
			isRemoving: false,
			isSaving: false,
			actions: duplicateVar(macroItemActions),
			actionCustom: duplicateVar(macroItemActionsCustom),
			hover: false,
			isSavingCustom: false,
			isSavingIndex: false,
			index: '',
			delay: '',
		};
	},
	methods: {
		initData() {
			const rundownItem = duplicateVar(this.data.rundownItem);
			this.selectedRundownItem = rundownItem;
			this.index = this.data.layer_index || rundownItem.layer_index;
			this.delay = this.data.delay;
			const status = this.data.status;
			const action = this.actions.find(({ key }) => key === status);
			if (action) {
				this.selectedAction = action;
			} else {
				this.selectedAction = duplicateVar(this.actions[0]);
			}
		},
		initDataCustom() {
			const status = this.data.status;
			this.delay = this.data.delay;
			const actionCustom = this.actionCustom.find(({ key }) => key === status);
			if (actionCustom) {
				this.selectedAction = actionCustom;
			} else {
				this.selectedAction = duplicateVar(this.actionCustom[0]);
			}
		},
		remove() {
			const item = this.data;
			this.isRemoving = true;
			const callback = () => {
				this.$emit('remove', item);
				this.isRemoving = false;
			};
			const errorCallback = () => {
				this.isRemoving = false;
			};
			macroItemsApi.delete(item.id, callback, errorCallback);
		},
		edit() {
			this.isEdit = true;
			if (this.data.rundown_item_id) {
				this.initData();
			} else {
				this.initDataCustom();
			}
		},
		save() {
			this.isSaving = true;
			const rundownItemId = this.selectedRundownItem && this.selectedRundownItem.id ? this.selectedRundownItem.id : '';
			const action = this.selectedAction.key;
			const params = {
				// action,
				status: action,
				delay: this.delay,
				layer_index: this.index,
			};
			if (rundownItemId) params.rundown_item_id = rundownItemId;
			const callback = (response) => {
				const item = response.data;
				this.$emit('update', item);
				this.isSaving = false;
				this.isEdit = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			macroItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		// onSaveIndex() {
		// 	delay(() => {
		// 		this.saveIndex();
		// 	}, 300);
		// },
		// saveIndex() {
		// 	const rundownItemId = this.selectedRundownItem.id;
		// 	this.isSavingIndex = true;
		// 	const callback = () => {
		// 		this.isSavingIndex = false;
		// 	};
		// 	const errorCallback = () => {
		// 		this.isSavingIndex = false;
		// 	};
		// 	const params = {
		// 		layer_index: this.index,
		// 	};
		// 	rundownItemsApi.update(rundownItemId, params, callback, errorCallback);
		// },
		saveCustomCommand() {
			this.isSavingCustom = true;
			const action = this.selectedAction.key;
			const params = {
				// action,
				status: action,
			};
			const callback = (response) => {
				const item = response.data;
				this.$emit('update', item);
				this.isSavingCustom = false;
				this.isEdit = false;
			};
			const errorCallback = () => {
				this.isSavingCustom = false;
			};
			macroItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		selectItem(item) {
			this.selectedRundownItem = item;
		},
		selectAction(action) {
			this.selectedAction = action;
		},
	},
	created() {
		// this.initData();
	},
	computed: {
		notRundown() {
			return this.data
			&& this.data.status !== 'play_previous'
			&& this.data.status !== 'play_next'
			&& this.data.status !== 'stop_all'
			&& this.data.status !== 'clear_output';
		},
	},
};
</script>
